import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRecentMealsFromPast,
  getUserFavroiteMealData
} from "../../api/mealsApi";

// Async thunk for fetching all meals with pagination
export const getRecentMeals = createAsyncThunk(
  "meals/getRecentMeals",
  async (
    {
      currentDate,
      type,
      userId,
      searchTerm = "",
      limit = 0,
      page = 0,
      favoritePage,
      favoriteLimit
    },
    thunkAPI
  ) => {
    try {
      const response = await getRecentMealsFromPast(
        currentDate,
        userId,
        type,
        searchTerm,
        limit,
        page,
        favoritePage,
        favoriteLimit
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getUserFavoriteMeals = createAsyncThunk(
  "meals/getUserFavoriteMeals",
  async ({ currentDate, userId, limit = 0, page = 0 }, thunkAPI) => {
    try {
      const response = await getUserFavroiteMealData(
        currentDate,
        userId,
        limit,
        page
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Initial state
const initialState = {
  allMeals: [], // holds the meals data
  userMeals: [], // holds the user meals data
  userFavoriteMeals: [],
  pagination: {},
  favoritePagination: {},
  loading: false, // loading state for getCurrentDateMeal
  favLoading: false, // loading state for getCurrentDateMeal
  error: null // error state
};

const mealsSlice = createSlice({
  name: "meals",
  initialState,
  reducers: {
    updateMealsData: (state, action) => {
      if (
        state?.allMeals?.length ||
        state?.userMeals?.length ||
        state?.userFavoriteMeals?.length
      ) {
        state.allMeals = state.allMeals.map((item) => {
          if (item._id === action.payload.mealId) {
            if ([true, false]?.includes(action.payload?.likedByUser)) {
              return {
                ...item,
                likedByUser: action.payload.likedByUser,
                likeCount: action.payload.likedByUser
                  ? item.likeCount + 1
                  : item.likeCount - 1
              };
            }
            if ([true, false]?.includes(action.payload?.favouriteByUser)) {
              return {
                ...item,
                favouriteByUser: action.payload.favouriteByUser
              };
            }
          }
          return item;
        });
        state.userMeals = state.userMeals.map((item) => {
          if (item._id === action.payload.mealId) {
            if ([true, false]?.includes(action.payload?.likedByUser)) {
              return {
                ...item,
                likedByUser: action.payload.likedByUser,
                likeCount: action.payload.likedByUser
                  ? item.likeCount + 1
                  : item.likeCount - 1
              };
            }
            if ([true, false]?.includes(action.payload?.favouriteByUser)) {
              return {
                ...item,
                favouriteByUser: action.payload.favouriteByUser
              };
            }
          }
          return item;
        });
        state.userFavoriteMeals = state.userFavoriteMeals.map((item) => {
          if (item._id === action.payload.mealId) {
            if ([true, false]?.includes(action.payload?.likedByUser)) {
              return {
                ...item,
                likedByUser: action.payload.likedByUser,
                likeCount: action.payload.likedByUser
                  ? item.likeCount + 1
                  : item.likeCount - 1
              };
            }
            if ([true, false]?.includes(action.payload?.favouriteByUser)) {
              return {
                ...item,
                favouriteByUser: action.payload.favouriteByUser
              };
            }
          }
          return item;
        });
      }
    },
    resetMealData: () => initialState
  },
  extraReducers: (builder) => {
    builder
      // Handling getRecentMeals actions
      .addCase(getRecentMeals.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRecentMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.pagination = action.payload.pagination; // assuming response has meals data
        if (action.payload.userId) {
          state.userMeals = action.payload.meals; // assuming response has meals data
          // state.userFavoriteMeals = action.payload.favoriteMeals; // assuming response has meals data
        } else state.allMeals = action.payload.meals; // assuming response has meals data
      })
      .addCase(getRecentMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserFavoriteMeals.pending, (state) => {
        state.favLoading = true;
      })
      .addCase(getUserFavoriteMeals.fulfilled, (state, action) => {
        state.favLoading = false;
        state.favoritePagination = action.payload.favoritePagination; // assuming response has meals data
        state.userFavoriteMeals = action.payload.favoriteMeals; // assuming response has meals data
      })
      .addCase(getUserFavoriteMeals.rejected, (state, action) => {
        state.favLoading = false;
        state.error = action.payload;
      });
  }
});

export const { updateMealsData, resetMealData } = mealsSlice.actions;
export default mealsSlice.reducer;
